
export const environment = {
  production: false,
  apiUrl: 'https://api.globalhousess.com/api',
  endPoints: 'api',
  port: '8080',
  symmetricKey: 'M5mjd46dfSAaiLP4',
  googleClientId: '715740423350-svipr78bug5tdouplujkr5amdq1e8fj9.apps.googleusercontent.com',
  requiredFieldText: "Campo requerido",
  invalidFormatText: "Formato inválido",
  paginatorTools: 20,
    stripePublishableKey: 'pk_test_YOUR_STRIPE_KEY_HERE',
  binanceApiKey: 'YOUR_BINANCE_API_KEY_HERE',
  binanceMerchantId: 'YOUR_BINANCE_MERCHANT_ID_HERE'
}
